import Contact from './components/ContactForm/ContactForm';

export default Contact;
